<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="`Login to ${account.ClientName} [Reseller Accounts] :: MeritEHS`" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/resellers/accounts`">
                            <i class="fa fa-sitemap"></i> Reseller Accounts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/resellers/accounts/view/${account.SmartBizClientId}`">
                            {{ account.ClientName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        Login
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <form class="card mb-4" autocomplete="off">
                        <div class="card-header">Confirm Login</div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                               Confirm: You are about to login to {{ account.ClientName }}
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <button type="button" class="btn btn-warning" v-on:click="postLogin()" :disabled="processing">
                Login to {{ account.ClientName }} <i class="fa fa-spin fa-spinner" v-if="processing"></i>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                processing: false,
                account_id: this.$route.params.id,
                account_child_user: {},
                account: {},
            }
        },

        computed: {

        },

        methods: {

            getUser() {
                //Get the data
                this.$http
                    .get('resellers/accounts/view/'+this.account_id)
                    .then(response => {
                        //Set all the data
                        this.account = response.data.account;
                        this.account_child_user = response.data.account_child_user;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            postLogin() {
                //Loging
                this.processing = true;

                //Send it
                this.$http.postWeb(`reseller-login/${this.account.SmartBizClientId}`).then(() => {
                    //Set it
                    window.location = '/';
                });
            },
        },

        mounted() {
            //Get the incidents
            this.getUser();
        }
    }
</script>
